export default __webpack_public_path__ + "static/marketing_hero@2x-f734e68e239615e17b15e9768a4b411f.jpg";